var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_c('Header'),_c('div',{staticClass:"container"},[_c('router-view')],1),(_vm.isProcessing)?_c('ScreenGuard'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }